export class Http { 

    jSONInfo(config: any, option: any, callBack: any) {
        let cnfAjax: any = {
            url: config.dir
            , type: config.type
            , data: option
            , dataType: "json"
            , success: function (data: any) {
                if (typeof callBack == 'function') callBack(data);
            }
            , error: function (data: any, status: any, e: any) {
                console.error("jSONInfo - No se pudo cargar la pagina: ", data.responseText);
            }
        }
            , $files = config.Files
        if ($files != undefined && $files.length != 0) {
            cnfAjax.fileElementId = $files;
            //$.ajaxFileUpload(cnfAjax);
        }
        else {
            $.ajax(cnfAjax);
        }
    }
}